import React from "react";
import { Row, Table } from "reactstrap";
import { columnHeader } from "../../../../Transactions/transactionConfig";
import Pagination from "../../../../../../shared/components/pagination/Pagination";
import * as env from "../../../../../../env";
import client from "../../../../../../shared/api-client";
import toQueryString from "../../../../../../shared/toQueryString";
import * as CurrencyFormat from "react-currency-format";

class ProfileTransactions extends React.Component {
  state = {
    isOpen: false,
    transactionData: [],
    startIndex: 0,
    endIndex: env.RECORDS_PER_PAGE,
    progress: "",
  };

  getTransactions = () => {
    this.setState({
      isOpen: false,
      transactionData: [],
    });

    let params = toQueryString({
      uid: this.props.id,
    });

    this.setState({
      progress: "Loading ...",
    });

    client(`user_transactions.php?${params}`).then(
      (response) => {
        this.setState({
          isOpen: false,
          transactionData: response,
          progress: response.length === 0 ? "No record found" : "",
        });
      },
      (error) => {
        console.error(error);
      }
    );
  };

  printRecords = () => {
    let items = this.state.transactionData.slice(
      this.state.startIndex,
      this.state.endIndex + 1
    );

    return (
      <React.Fragment>
        {items.map((obj, tIndex) => (
          <tr key={tIndex}>
            {columnHeader.map((header, index) =>
              header.key === "credits" ? (
                <td key={index} className="textRight">
                  <CurrencyFormat
                    value={obj[header.key]}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={"$"}
                  />
                </td>
              ) : (
                <td key={header.name}>{obj[header.key]}</td>
              )
            )}
          </tr>
        ))}
      </React.Fragment>
    );
  };

  pagination = () => {
    return this.state.transactionData.length > env.RECORDS_PER_PAGE ? (
      <div className="audit-trail-footer">
        <Pagination
          items={this.state.transactionData}
          onChangePage={(pagination) => this.setState(pagination)}
          pageSize={env.RECORDS_PER_PAGE}
        />
      </div>
    ) : (
      ""
    );
  };

  componentDidMount() {
    this.getTransactions();
  }

  render() {
    return (
      <React.Fragment>
        <Row>
          <Table
            className="table--head-accent table--bordered"
            responsive
            hover
          >
            <thead>
              <tr key="profileTransactionsHeader">
                {columnHeader.map((header) => (
                  <th key={header.name}>{header.name}</th>
                ))}
              </tr>
            </thead>
            <tbody>{this.printRecords()}</tbody>
          </Table>
          {this.pagination()}
          {this.state.progress}
        </Row>
      </React.Fragment>
    );
  }
}

export default ProfileTransactions;
